import { KeyPrefixList, zKey } from '@nucleus/ncu-key-prefix';

export const PublishableSubscriptionServiceEntitySchema = {
  subscriptionListId: zKey.prefixedByKey(KeyPrefixList).optional(),
};
